import { AIRO_CORE, isAiroLicensed } from "../../services/license.service";
import {
  Component,
  Inject,
  Optional,
  ViewEncapsulation,
  OnInit,
} from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { Constants } from "../../constant/constant";
import { LoggingService } from "../../../logging.service";
import { environment } from "../../../../environments/environment";
import { APP_NAME } from "../../../app.module";
import { LicenseService } from "../../services/license.service";

const TREE_DATA: any[] = [

  {
    name: "Performance Lighthouse",
    module: "module.balancedscorecard",
    children: [
      { name: "Balanced Scorecard", url: "/balancedscorecard/dashboard" },
      { name: "BVTI Index", url: "/bvt-index" },
    ],
  },
  {
    name: "Financial Performance",
    module: "module.finhub",
    children: [
      { name: "FinHub", url: "project-finance/finance-hub" },
      { name: "FinOps Hub", url: "finops-hub" },
    ],
  },
  { name: "Delivery Risk Net", module: "module.risknet", url: "/riskconvergence", type: "standalone" },
  {
    name: "Strategic Relevance Monitor",
    module: "module.okrconvergence",
    url: "/okrconvergence",
    type: "standalone",
  },
  // Mapping Expert Insights path as base
  { name: "Delivery Lens", module: "module.deliverylens", url: "/delivery/projects", type: "standalone" },
  {
    name: "Cognitive Sourcing",
    module: "module.cognitivesourcing",
    children: [
      { name: "Opportunity Workbench", url: "/program" },
      { name: "Deal Structure", url: "/deal-structure" },
      { name: "Contracts Intel", url: "contracts-intel" },
    ],
  },
  {
    name: "Innovation Workbench",
    module: "module.innovationworkbench",
    children: [
      {
        name: "Idea Workbench",
        url: "/ideapitch",
      },
      { name: "Signals", url: "signals" },
      { name: "Hackathons", url: "challenge-workbench" },
    ],
  },
  {
    name: "Tech Governance Lighthouse",
    module: "module.governancelighthouse",
    url: "strategicRelevance/governancect",
    type: "standalone",
  },
  {
    name: "Assessments & Surveys",
    module: "module.assessment_and_survey",
    url: "strategicRelevance/assessment-central",
    type: "standalone",
    matching_urls: ["performanceInsights/survey-central"],
  },
  {
    name: "Plan Central",
    module: "module.plancentral",
    url: "/confluence/teamplantracker",
    type: "standalone",
    matching_urls: [
      "confluence/plan",
      "confluence/teamplantemplates?readMode=0",
      "confluence/teamplantemplates?ipdb=1",
    ],
  },
  {
    name: "Tech Map & SOC Support",
    module: "module.techmap",
    children: [
      {
        name: "Tech Map",
        url: "application-master",
      },
      { name: "SOC Workbench", url: "incidentracker/security-incidents" },
    ],
  },
  {
    name: "Parade",
    url: "parade",
    type: "standalone",
  },
];

const VENDOR_MENU_DATA: any[] = [
  { name: "Delivery Lens", module: "module.deliverylens", url: "/delivery/projects", type: "standalone" },
  {
    name: "Performance Lighthouse",
    module: "module.balancedscorecard",
    children: [
      { name: "Balanced Scorecard", url: "/balancedscorecard/dashboard" },
      { name: "Pulse", url: "performanceInsights/pulse" },
    ],
  },
  {
    name: "Cognitive Sourcing",
    module: "module.cognitivesourcing",
    children: [{ name: "Opportunity Workbench", url: "/program" }],
  },
  {
    name: "Innovation Workbench",
    module: "module.innovationworkbench",
    children: [
      {
        name: "Idea Workbench",
        url: "/challenge-workbench/challenge-statements",
        matching_urls: [
          "/challenge-workbench/challenge-statements",
          "ideapitch",
        ],
      },
    ],
  },
];

const RUBIN_MENU_DATA: any[] = [
  {
    name: "Compliance",
    module: "module.compliance",
    url: "/incidentracker",
    type: "standalone",
    matching_urls: [
      "/incidentracker/compliance-details",
      "/incidentracker/clause-details",
    ],
    exact_url: true,
  },
  {
    name: "Audits",
    module: "module.audits",
    url: "/incidentracker/audits",
    type: "standalone",
    matching_urls: ["/incidentracker/templates", "/incidentracker/instance"],
  },
  { name: "Risk Net", module: "module.risknet", url: "/riskconvergence", type: "standalone" },
  {
    name: "Tech Map & SOC Support",
    module: "module.techmap",
    children: [
      {
        name: "Tech Map",
        url: "application-master",
      },
      { name: "SOC Workbench", url: "incidentracker/security-incidents" },
    ],
  },
  {
    name: "Performance & Controls Monitor",
    module: "module.balancedscorecard",
    children: [
      { name: "Balanced Scorecard", url: "/balancedscorecard/dashboard" },
      { name: "BVTI Index", url: "/bvt-index" },
    ],
  },
  {
    name: "Controls Testing & Assessments",
    module: "module.assessment_and_survey",
    url: "strategicRelevance/assessment-central",
    type: "standalone",
    matching_urls: ["performanceInsights/survey-central"],
  },
  {
    name: "Tech Governance Lighthouse",
    module: "module.governancelighthouse",
    url: "strategicRelevance/governancect",
    type: "standalone",
  },
  {
    name: "Plan Central",
    module: "module.plancentral",
    url: "/confluence/teamplantracker",
    type: "standalone",
    matching_urls: [
      "confluence/plan",
      "confluence/teamplantemplates?readMode=0",
      "confluence/teamplantemplates?ipdb=1",
    ],
  },

  { name: "Initiatives Lens", module: "module.deliverylens", url: "/delivery/projects", type: "standalone" },

  {
    name: "Parade",
    url: "parade",
    type: "standalone",
  },
];
@Component({
  selector: "app-side-menu",
  templateUrl: "./side-menu.component.html",
  styleUrls: ["./side-menu.component.scss"],
  encapsulation: ViewEncapsulation.Emulated,
})
export class SideMenuComponent implements OnInit {
  mainmenu: any[] = [];
  user: any;
  activeGroupIndex: number | null = null;

  constructor(
    private readonly route: Router,
    private readonly activeroute: ActivatedRoute,
    private readonly loggingService: LoggingService,
    private readonly licenseService: LicenseService,
    @Optional() @Inject(APP_NAME) public appName: string = "kepler"
  ) {
    this.user = JSON.parse(localStorage.getItem("permission") ?? "{}");

    let menu: any[];
    if (this.appName === "rubin") {
      menu = RUBIN_MENU_DATA;
    } else {
      menu = this.user?.is_vendor ? VENDOR_MENU_DATA : TREE_DATA;
    }
    this.mainmenu = this.withLicenceLocks(menu);
  }

  /**
   * A copy of the menu where each top-level item has `locked`: its module is not licensed,
   * or it is the link to Airo and the tenant has no valid Airo licence.
   */
  private withLicenceLocks(menu: any[]): any[] {
    const licensed = this.licenseService.licensedModules();
    const airoLinkLocked = !isAiroLicensed(AIRO_CORE);
    return menu.map((item) => ({
      ...item,
      locked:
        !this.licenseService.isLicensed(item.module, licensed) ||
        (airoLinkLocked && this.opensAiro(item.url)),
    }));
  }

  /** Same test navigateUrl uses to decide a menu item opens Airo. */
  private opensAiro(url: any): boolean {
    return !!url && url.indexOf("external") === -1 && url.indexOf("airo") > -1;
  }

  ngOnInit(): void {
    this.activeroute.params.subscribe(() => {
      this.evaluateActiveState();
    });
  }

  isUrlMatch(element: any): boolean {
    if (!element) return false;
    const currentUrl = this.route?.url ?? "";

    if (element.url) {
      const urlMatches = element.exact_url
        ? this.isExactSegmentMatch(currentUrl, element.url) // exact for flagged items
        : currentUrl.includes(element.url); // existing behaviour for all others

      if (urlMatches) return true;
    }

    if (Array.isArray(element.matching_urls)) {
      return element.matching_urls.some((m: string) => currentUrl.includes(m));
    }

    return false;
  }

  private isExactSegmentMatch(currentUrl: string, targetUrl: string): boolean {
    const normalize = (url: string) => url.replace(/^\/+/, "").split("?")[0];
    const normalizedCurrent = normalize(currentUrl);
    const normalizedTarget = normalize(targetUrl);

    return (
      normalizedCurrent === normalizedTarget ||
      normalizedCurrent.startsWith(normalizedTarget + "?")
    );
  }

  toggleGroup(index: number): void {
    if (this.mainmenu[index]?.locked) {
      return;
    }
    this.activeGroupIndex = this.activeGroupIndex === index ? null : index;
  }

  evaluateActiveState(): void {
    setTimeout(() => {
      for (let i = 0; i < this.mainmenu.length; i++) {
        const item = this.mainmenu[i];

        if (item.locked) {
          continue;
        }

        if (item.type === "standalone" && this.isUrlMatch(item)) {
          return; // Root element handled, terminate search cascade loop
        }

        const children = item.children || [];
        for (const child of children) {
          if (
            this.isRouteMatch("survey-details", child.url, "hubble", i) ||
            this.isRouteMatch(
              "challenge-workbench",
              child.url,
              "challenge-workbench",
              i
            ) ||
            this.isRouteMatch(
              "delivery-accelerator",
              child.url,
              "delivery-accelerator",
              i
            ) ||
            this.isRouteMatch(
              "confluence",
              child.url,
              "confluence/teamplantracker",
              i,
              ["confluence/teamplantemplates", "confluence/plan"]
            ) ||
            this.isUrlMatch(child)
          ) {
            this.activeGroupIndex = i;
            return;
          }
        }
      }
    }, 100);
  }

  isRouteMatch(
    routeKey: string,
    elementUrl: string,
    matchUrl: string,
    index: number,
    additionalUrls: string[] = []
  ): boolean {
    if (
      this.route?.url?.includes(routeKey) &&
      (elementUrl.includes(matchUrl) ||
        additionalUrls.some((url) => elementUrl.includes(url)))
    ) {
      this.activeGroupIndex = index;
      return true;
    }
    return false;
  }

  navigateUrl(url: any): void {
    if (url && url.indexOf("external") > -1) {
      this.navigateToSP();
    } else if (url && url.indexOf("airo") > -1) {
      this.navigateToAiro();
    } else if (url) {
      this.route.navigateByUrl(url);
    } else {
      this.loggingService.warn("Unexpected value");
    }
  }

  openBlank(url: any): void {
    window.open(url, "_blank");
  }

  navigateToSP(): void {
    window.open(Constants.SHAREPOINT_URL, "_blank");
  }

  navigateToAiro(): void {
    this.openBlank(environment.airoFrontendURL);
  }
}
